var $e0321b43bdefb8b3$exports = {};
$e0321b43bdefb8b3$exports = {
    "Clear search": `Obri\u{161}i pretragu`
};


export {$e0321b43bdefb8b3$exports as default};
//# sourceMappingURL=hr-HR.module.js.map
